"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeadSearchableCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const MosaicIcon_1 = require("../../../../Shared/Components/MosaicIcon");
const TableHeadSearchableCell = ({ cellInfo, className, resetFilterLabel, isNoData, onSearchFilterChange, searchInputAriaLabel, searchTerm, }) => {
    const cellName = cellInfo.name;
    const [isSearchApplied, setIsSearchApplied] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState(searchTerm);
    const [lastSearchedValue, setLastSearchedValue] = React.useState('');
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        if (searchTerm === '') {
            setSearchValue(searchTerm);
            setIsSearchApplied(false);
        }
    }, [searchTerm]);
    const onInputChange = (event) => {
        setSearchValue(event.target.value);
    };
    const resetSearchFilter = () => {
        setIsSearchApplied(false);
        setLastSearchedValue('');
        if (searchValue) {
            setSearchValue('');
        }
        onSearchFilterChange(cellName, '');
    };
    const makeSearchFilter = () => {
        setIsSearchApplied(true);
        setLastSearchedValue(searchValue);
        onSearchFilterChange(cellName, searchValue);
    };
    const onSearchButtonClick = () => {
        if (searchValue !== lastSearchedValue) {
            makeSearchFilter();
        }
        else if (isSearchApplied && searchValue === lastSearchedValue) {
            resetSearchFilter();
        }
    };
    const onInputKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (isSearchApplied && searchValue === '') {
                resetSearchFilter();
            }
            else if (searchValue !== lastSearchedValue) {
                makeSearchFilter();
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)("th", { className: `th-searchable ${className}`, "data-filter-group": cellName, scope: "col", children: (0, jsx_runtime_1.jsx)("div", { className: "table--nested table w-full", children: (0, jsx_runtime_1.jsxs)("div", { className: "table--nested-row gap-2xs flex items-center", children: [(0, jsx_runtime_1.jsxs)("div", { className: "table--nested-cell table-cell align-middle text-left", children: [(0, jsx_runtime_1.jsx)("span", { children: cellInfo.label }), "\u00A0"] }), !isNoData && ((0, jsx_runtime_1.jsx)("div", { className: "w-full", children: (0, jsx_runtime_1.jsxs)("div", { className: "table--searchable form-input-container sm addon-start", children: [(0, jsx_runtime_1.jsx)("input", { ref: inputRef, onChange: onInputChange, onKeyDown: onInputKeyDown, value: searchValue, type: "text", "aria-label": searchInputAriaLabel, className: "table--searchable__input form-input pr-2xs h-[32px]" }), (0, jsx_runtime_1.jsxs)("button", { type: "button", className: "table--searchable__btn", onClick: onSearchButtonClick, "aria-label": isSearchApplied ? resetFilterLabel : searchInputAriaLabel, children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "search-outline", className: "icon-md addon-content" }), isSearchApplied ? ((0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "cancel-outline", className: "icon-md addon-content left-auto! right-[5px]!" })) : null] })] }) }))] }) }) }, cellName));
};
exports.TableHeadSearchableCell = TableHeadSearchableCell;
